import { cn } from "@/lib/utils";

// ---------------------------------------------------------------------------
// GreetingBanner - saudacao personalizada com horario
// ---------------------------------------------------------------------------

interface GreetingBannerProps {
  name: string | null;
  className?: string;
}

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

function GreetingBanner({ name, className }: GreetingBannerProps): JSX.Element {
  const displayName = name?.trim() || "usuário";
  const greeting = getGreeting();

  return (
    <div className={cn("flex flex-col", className)}>
      <h1 className="text-xl font-semibold leading-tight tracking-tight text-foreground">
        {greeting}, {displayName}!
      </h1>
      <p className="text-sm text-muted-foreground mt-0.5">
        Aqui está o resumo da sua loja hoje.
      </p>
    </div>
  );
}

export { GreetingBanner };
